import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmallInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.4375 4.29688C3.4375 4.08114 3.61239 3.90625 3.82812 3.90625H5.07812C5.29386 3.90625 5.46875 4.08114 5.46875 4.29688V7.65625C5.46875 7.87199 5.29386 8.04688 5.07812 8.04688C4.86239 8.04688 4.6875 7.87199 4.6875 7.65625V4.6875H3.82812C3.61239 4.6875 3.4375 4.51261 3.4375 4.29688Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.26172 7.73438C3.26172 7.51864 3.43661 7.34375 3.65234 7.34375H6.34766C6.56339 7.34375 6.73828 7.51864 6.73828 7.73438C6.73828 7.95011 6.56339 8.125 6.34766 8.125H3.65234C3.43661 8.125 3.26172 7.95011 3.26172 7.73438Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 3.125C4.87639 3.125 4.75555 3.08834 4.65277 3.01967C4.54999 2.95099 4.46988 2.85338 4.42258 2.73918C4.37527 2.62497 4.36289 2.49931 4.38701 2.37807C4.41113 2.25683 4.47065 2.14547 4.55806 2.05806C4.64547 1.97065 4.75683 1.91113 4.87807 1.88701C4.99931 1.86289 5.12497 1.87527 5.23918 1.92258C5.35338 1.96988 5.45099 2.04999 5.51967 2.15277C5.58834 2.25555 5.625 2.37639 5.625 2.5C5.625 2.66576 5.55915 2.82473 5.44194 2.94194C5.32473 3.05915 5.16576 3.125 5 3.125Z",
			fill: "white"
		})
	]
});
export default SvgSmallInfo;
